// tabs.js calls UX.dropBlock.init(); on line 260
// profile-menu.js calls UX.dropBlock.init(); on line 53

(function () {
    var $window = $(window),
        $body = $('body');

    var dropBlock = {
        $controllers: $('[data-db-target-for]'),
        $targets: null, // Holds all targets in Dom
        $controller: null, // Current drop down controller
        $target: null, // Current target down controller element
        $parents: null, // Hodls all parents in Dom
        $parent: null, // Current parent element
        escape: 27,
        $container: $('.container'),
        switchVal: null,
        $section: $('.dropBlock__holder'),
        vPort: 'screen-sm',
        isMobile: false,
        initialized: false,
        direction: 'left', // left , right
        pop: 'down', // up , down
        switchClass: null,

        init: function () {
            dropBlock.control();
        },

        control: function () {
            if (dropBlock.initialized) {
                return;
            }
            dropBlock.initialized = true;

            $(document).on('click', '[data-db-target-for]', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const isOpen = $(this).hasClass('js--open'),
                    isDataSlideTarget = $(this).is('[data-slide-target]'),
                    disableOnMobile = $(this).data('db-sm-disable') || false;

                dropBlock.$controller = $(this);
                dropBlock.find.target();

                if (isOpen) {
                    dropBlock.on.hide();
                } else {
                    if (dropBlock.isMobile && (isDataSlideTarget !== false || disableOnMobile)) {
                        return;
                    } else {
                        dropBlock.on.show(e);
                    }
                }
            });

            $(document).on(
                'click',
                '.coolBar:not(.loi__banner) [data-db-target-of] a:not([data-slide-target])',
                function (e) {
                    dropBlock.on.hide();
                }
            );

            $window.on('resize', function () {
                if (dropBlock.$parent != null) {
                    dropBlock.find.dimensions();
                }
            });

            $(document).on(dropBlock.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                dropBlock.isMobile = true;
            });
            $(document).on(dropBlock.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                dropBlock.isMobile = false;
            });

            dropBlock.additionalcontrol();
        },
        on: {
            show: function (e) {
                // show  target element

                if (!dropBlock.$controller.closest('.dropBlock__holder').length) {
                    if (typeof UX.controller != 'undefined') {
                        UX.controller.check(e);
                    }
                }

                if (dropBlock.$target) {
                    dropBlock.$controller.trigger('dropBlock:open', [dropBlock]);

                    dropBlock.$target.addClass('js--open');
                    dropBlock.$controller.addClass('js--open');
                    $body.attr('data-active', 'dropBlock');
                    dropBlock.$target.closest("[class*='sticko']").addClass('js--open');
                    dropBlock.switch.icon();
                    // Move focus to active inner component, or leave focus on control
                    dropBlock.$target.find('.active :tabbable').first().focus();

                    // Accessibility
                    dropBlock.$controller.attr({'aria-expanded': 'true'});
                    dropBlock.$target.removeAttr('aria-hidden');

                    // @fixme - this should not be here at all - it should be moved to proper component
                    const isLoi = dropBlock.$target.find('.loi').length > 0;
                    if (isLoi) {
                        dropBlock.$target.find('.loi__list').each(function () {
                            UX.loi.on.recalculate($(this));
                        });
                    }
                    dropBlock.$controller.trigger('dropBlock:opened', [dropBlock]);
                }
                dropBlock.additionalOnShow();
            },
            hide: function () {
                // hide target element
                if (dropBlock.$target) {
                    dropBlock.$controller.trigger('dropBlock:close', [dropBlock]);

                    // Close current target
                    dropBlock.$controller.removeClass('js--open');
                    dropBlock.$target.removeClass('js--open');
                    // Play nicely with others ...
                    // For plugins which don't use js--open class but uses .hide .show methods instead, reset them ...
                    // For example LOA accordion
                    if (dropBlock.$target.attr('style')) {
                        dropBlock.$target.removeAttr('style');
                    }
                    // Explicitly for our accordion working as a drop-block
                    dropBlock.$target.closest("[class*='accordion-tabbed__tab']").removeClass('js--open');

                    dropBlock.$target.closest("[class*='sticko']").removeClass('js--open');

                    dropBlock.switch.back();

                    // Accessibility - Inform screen readers
                    dropBlock.$controller.attr({'aria-expanded': 'false'});
                    const activeEl = document.activeElement;
                    if (!dropBlock.$target.has(activeEl).length) {
                        dropBlock.$target.attr({'aria-hidden': 'true'});
                    } else {
                        // Move focus to a safe place before hiding
                        dropBlock.$controller.focus();
                        dropBlock.$target.attr({'aria-hidden': 'true'});
                    }

                    // Nested dropBlocks close handling
                    if (dropBlock.$parentSection && dropBlock.$parentSection.length) {
                        // Nested ones - set parent after closing self - will close parent in second round
                        dropBlock.$controller = $(
                            '[data-db-target-for="' + dropBlock.$parentSection.attr('data-db-target-of') + '"]'
                        );
                        dropBlock.find.target();
                    } else {
                        // If we want to close last drop block, than there is no more active component
                        if ($body.attr('data-active') === 'dropBlock') {
                            $body.removeAttr('data-active');
                            $('body, html').removeClass('lock-screen'); // @todo investigate if this is needed for drop Blocks or was copied out of other component
                        }
                    }
                    if (dropBlock.$target) {
                        dropBlock.$target.find('input:focus').blur();
                    }
                    dropBlock.$controller.trigger('dropBlock:closed', [dropBlock]);
                }
                dropBlock.additionalOnHide();
            },
            escape: function () {
                // hide target if user clicks escape key
                // @fixme this seems unused and deprecated by controller.js
                if (dropBlock.$target != null) {
                    dropBlock.on.hide();
                }
            },
        },
        find: {
            target: function () {
                // get the target element if existed
                if ($('[data-db-target-of]').length) {
                    dropBlock.$targets = $('[data-db-target-of]');
                    dropBlock.$target = $(
                        '[data-db-target-of=' + dropBlock.$controller.attr('data-db-target-for') + ']'
                    );
                    dropBlock.$section = dropBlock.$target;
                    const $nested = dropBlock.$section.parents('.dropBlock__holder');
                    if ($nested.length) {
                        dropBlock.$parentSection = $nested;
                    } else {
                        dropBlock.$parentSection = null;
                    }
                    dropBlock.find.parent();
                }
            },
            parent: function () {
                // get the parent element if existed

                dropBlock.$parent = null;
                dropBlock.$parents = $('[data-db-parent-of]');

                if (dropBlock.$parents.length) {
                    dropBlock.$parents.each(function () {
                        const current = dropBlock.$controller.attr('data-db-target-for');
                        let parentFor = $(this).data('db-parent-of').split(',');

                        if (parentFor.indexOf(current) !== -1) {
                            dropBlock.$parent = $(this);
                            return false;
                        }
                    });

                    if (dropBlock.$parent != null) {
                        dropBlock.find.dimensions();
                        dropBlock.find.ifContaind();
                    }
                }
            },
            ifContaind: function () {
                // check if it parent or target has container element
                if (dropBlock.$parent.find('.container').length && !dropBlock.$target.find('.container').length) {
                    dropBlock.$target.wrapInner("<div class='container'></div>");
                }
            },
            dimensions: function () {
                // count the top and left position of the target element based on teh parent element

                var nHeight = dropBlock.$parent.outerHeight(),
                    pOffset = dropBlock.$parent.offset(),
                    pLeft = pOffset.left,
                    nWidth = dropBlock.$parent.innerWidth(),
                    styles = {},
                    container_offset = pOffset;

                dropBlock.$container = $('.container');
                if (dropBlock.$container.length) {
                    container_offset = dropBlock.$container.offset();
                }

                const container_left = container_offset.left,
                    container_base = container_left + dropBlock.$container.width(),
                    parent_base = nWidth + pLeft;

                if (dropBlock.$parent.find('.scrollThenFix').length) {
                    nHeight = dropBlock.$parent.find('.scrollThenFix').outerHeight();
                }

                if (dropBlock.$parent.innerWidth() === dropBlock.$controller.innerWidth()) {
                    nWidth = dropBlock.$parent.hasClass('no-auto-width') ? '' : 'auto';
                    if (dropBlock.isMobile) {
                        nWidth = dropBlock.$parent.hasClass('no-auto-width') ? '' : '100%';
                    }
                }

                if (parent_base > container_base) {
                    styles = {
                        top: nHeight,
                        right: '0px',
                        width: nWidth,
                    };
                } else {
                    styles = {
                        top: nHeight,
                        width: nWidth,
                    };
                    let direction = dropBlock.$parent.data('db-direction') || dropBlock.direction;
                    /*eslint-disable*/
                    switch (direction) {
                        case 'left':
                        case 'right':
                            styles[direction] = '0px';
                            break;
                        case 'center':
                            let offset = dropBlock.$target.innerWidth() / 2 - dropBlock.$parent.innerWidth();
                            styles['left'] = `calc(-50% - ${offset}px)`;
                    }
                    /*eslint-enable*/
                }
                dropBlock.$target.css(styles);
            },
        },
        switch: {
            icon: function () {
                dropBlock.switchVal = dropBlock.$controller.attr('data-db-switch');
                switch (dropBlock.switchVal) {
                    case 'none':
                        break;
                    case 'rotate':
                        dropBlock.$controller.find('i').addClass('js--rotated');
                        break;
                    default:
                        if (dropBlock.switchVal !== undefined) {
                            dropBlock.switchClass = dropBlock.$controller.find('i').attr('class');
                            dropBlock.$controller.find('i').removeClass().addClass(dropBlock.switchVal);
                        }
                }
            },
            back: function () {
                dropBlock.$controllers.each(function () {
                    var temp = $(this).attr('data-db-switch');
                    switch (temp) {
                        case 'none':
                            break;
                        case 'rotate':
                            dropBlock.$controller.find('i').removeClass('js--rotated');
                            break;
                        default:
                            if (temp !== undefined && $(this).attr('aria-expanded') == 'true') {
                                dropBlock.$controller.find('i').removeClass(temp).addClass(dropBlock.switchClass);
                            }
                    }
                });
            },
        },

        additionalOnShow: function () {},

        additionalOnHide: function () {},

        additionalcontrol: function () {},
    };

    UX.dropBlock = dropBlock; // add to global namespace
})();
